import React from 'react';
import Button from '@ramsey-design-system/button';

import '@ramsey-design-system/button/dist/button.css';

const RDSButton = (props: React.ComponentProps<typeof Button>) => (
  <Button {...props} />
);

export default RDSButton;
